'use client';

import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import AppImage from '@/components/ui/AppImage';


const navLinks = [
{ label: 'Home', href: '/' },
{ label: '2026 Finalists', href: '/2026-finalists' },
{ label: 'Voting', href: '/voting' }];


export default function SiteHeader() {
  const pathname = usePathname();
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-shadow duration-300 ${
      scrolled ? 'shadow-md' : ''}`
      }
      style={{ background: '#ffffff' }}>

      <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-10">
        <div className="flex items-center justify-between h-20 bg-white">
          {/* Logo */}
          <Link href="/" className="flex items-center gap-3 flex-shrink-0 text-xl">
            <div
              className="rounded-full overflow-hidden flex items-center justify-center"
              style={{ background: '#ffffff', width: 64, height: 64 }}>

              <AppImage
                src="/assets/images/12eef6ff-c410-4438-b75b-48bf1bf380ed-1784970622837.png"
                alt="Miss Universities of Gauteng logo — crown and pageant emblem"
                width={58}
                height={58}
                priority
                className="object-contain"
                style={{ background: '#ffffff' }} />

            </div>
            <div className="hidden sm:block">
              <p className="font-bold text-sm leading-tight tracking-wide text-rose-900">MISS UNIVERSITIES</p>
            </div>
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-1">
            {navLinks?.map((link) => {
              const isActive = pathname === link?.href;
              return (
                <Link
                  key={`nav-${link?.href}`}
                  href={link?.href}
                  className={`px-5 py-2 rounded-full text-sm font-600 tracking-wide transition-all duration-200 nav-link-hover ${
                  isActive ?
                  'bg-rose-900/10' : 'text-rose-900/80 hover:text-rose-900'}`
                  }
                  style={isActive ? { color: '#800000' } : { color: '#800000' }}>

                  {link?.label}
                </Link>);

            })}
            <Link
              href="/"
              className="ml-4 px-6 py-2 rounded-full text-sm font-700 btn-gold">

              Enter Now
            </Link>
          </nav>

          {/* Mobile Hamburger */}
          <button
            className="md:hidden flex flex-col gap-1.5 p-2 rounded-lg text-rose-900"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle navigation menu">

            <span
              className={`block w-6 h-0.5 bg-current transition-all duration-300 ${menuOpen ? 'rotate-45 translate-y-2' : ''}`} />

            <span
              className={`block w-6 h-0.5 bg-current transition-all duration-300 ${menuOpen ? 'opacity-0' : ''}`} />

            <span
              className={`block w-6 h-0.5 bg-current transition-all duration-300 ${menuOpen ? '-rotate-45 -translate-y-2' : ''}`} />

          </button>
        </div>
      </div>
      {/* Mobile Drawer */}
      <div
        className={`md:hidden transition-all duration-300 overflow-hidden ${
        menuOpen ? 'max-h-80 opacity-100' : 'max-h-0 opacity-0'}`
        }
        style={{ background: '#f9f9f9', borderTop: '1px solid #eee' }}>

        <nav className="px-4 py-4 flex flex-col gap-1">
          {navLinks?.map((link) => {
            const isActive = pathname === link?.href;
            return (
              <Link
                key={`mob-nav-${link?.href}`}
                href={link?.href}
                onClick={() => setMenuOpen(false)}
                className={`px-4 py-3 rounded-lg text-sm font-600 tracking-wide transition-all duration-200 ${
                isActive ? 'bg-rose-900/10' : 'hover:bg-rose-900/5'}`
                }
                style={{ color: isActive ? '#800000' : '#800000' }}>

                {link?.label}
              </Link>);

          })}
          <Link
            href="/"
            onClick={() => setMenuOpen(false)}
            className="mt-2 px-4 py-3 rounded-lg text-sm font-700 btn-gold text-center">

            Enter Now
          </Link>
        </nav>
      </div>
    </header>);

}